const TRACKING_SITE_NAVIGATION = 'tracking_site_navigation';

export {
  TRACKING_SITE_NAVIGATION,
};
